import React from 'react';
import BetSectionHeader from './betSectionHeader';
import RangeSlider from './rangeSlider';
import BetSectionFooter from './betSectionFooter';

const BetSection = ({
  t,
  onBlur,
  range,
  maxOdd,
  minOdd,
  limits,
  setRange,
  balance,
  onChange,
  betAmount,
  autoBetData,
  currentWinOdd,
  activeFreeBet,
  currencySymbol,
  setCurrentWinOdd,
  showNotification,
  handleOpenNumPad,
  changeBetInputValue,
  isDisabledBetSection,
  handleChangeInputValue,
}) => {
  return (
    <>
      <div className='striker-bet-section'>
        <div className='striker-b-s-holder'>
          <BetSectionHeader
            t={t}
            range={range}
            betAmount={betAmount}
            activeFreeBet={activeFreeBet}
            currencySymbol={currencySymbol}
            setCurrentWinOdd={setCurrentWinOdd}
          />
          <RangeSlider
            range={range}
            setRange={setRange}
            maxOdd={maxOdd}
            minOdd={minOdd}
            autoBetData={autoBetData}
          />
          <BetSectionFooter
            t={t}
            onBlur={onBlur}
            limits={limits}
            balance={balance}
            onChange={onChange}
            betAmount={betAmount}
            autoBetData={autoBetData}
            currentWinOdd={currentWinOdd}
            activeFreeBet={activeFreeBet}
            isDisabled={isDisabledBetSection}
            changeBetAmount={changeBetInputValue}
            showNotification={showNotification}
            handleOpenNumPad={handleOpenNumPad}
            handleChangeInputValue={handleChangeInputValue}
          />
        </div>
      </div>
    </>
  );
};

export default BetSection;
